import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { MolImageService, SearchService, StateMap, UnitOfWork, UserManager } from '../../services/common';
import { LocationFns, UtilFns } from '../../utils/common';
import { ColumnSorter, PageState } from '../../controls/common';
import { Material, MaterialAlertRule } from '../../entities/EntityModels';
import { StructureAlertListItem } from '../../entities/projections/StructureAlertListItem';
import { environment } from '../../../environments/environment';

import {HttpClient, HttpHeaders, HTTP_INTERCEPTORS} from '@angular/common/http';
import {Observable} from 'rxjs';
@Component({
    selector: 'prediction-hh-alert',
    templateUrl: './prediction-hh-alert.html',
})
export class PredictionHHAlertComponent implements OnInit {
    @Input() materialId: number;
    material: Material;
    _score: StructureAlertListItem;
    _scoreNotFound: boolean;
    _materialAlertRules: MaterialAlertRule[];
    _pageState = new PageState('Prediction Alert');
    _colSorter: ColumnSorter;

    _documentManagementUrl: string;
    _isLoading = false;
    _validationMessage: string;

    constructor(public _uow: UnitOfWork, public _stateMap: StateMap, public _searchService: SearchService,
                public _molImageService: MolImageService, public _location: Location, public _userManager: UserManager,
                public _httpClient: HttpClient) {

    }

    ngOnInit() {
        this.material = this._stateMap.currentMaterial;
        LocationFns.setTab(this._location, '0.0');
        const params = {materialId: this.materialId};

        this._uow.fetch('fetchStructureAlertListItem', params).then(r => {
            this._scoreNotFound = (r.length == 0);
            if (this._scoreNotFound) {
                return;
            }
            this._score = <StructureAlertListItem><any>r[0];
        });

        this._uow.materialAlertRuleRepository.whereWithParams(params).then(r => {
            this._materialAlertRules = r;
        });

        this._uow.getDocumentManagementUrl().then(url => {
            this._stateMap.documentManagementBaseUrl = url;
            this._documentManagementUrl = this._stateMap.documentManagementBaseUrl  + '/RIFMDownloadableFile';
        });

        this._colSorter = new ColumnSorter(this, {
            'Rule': (mar: MaterialAlertRule) => UtilFns.formatNumber(mar.rule, 3)
        }, 'Rule', (sortColumn) => this._pageState.sortColumn = sortColumn);
    }

    getSmileUrl(material: Material) {
        return this._molImageService.getImageUrlForSmile(material.smiles);
    }

    hasStockImage(mar: MaterialAlertRule) {
        // Synced up value in TypeAlertRules table so the GIF value is null when the image is missing.
        return (mar.typeAlertRule.gIF != null);
    }

    getStockImage(mar: MaterialAlertRule) {
        return environment.assetsUrl + 'assets/images/' + mar.rule + '.png';
    }

    sortWith(colSorter: ColumnSorter) {
        colSorter.sort(this._materialAlertRules);
    }

    downloadFile(fileName: string) {
        return this.exportReportFile(fileName, 'PublicReferences');
    }

    // ************************************************************************
    // document management web api url
    // ************************************************************************
    getDownloadFileURL(fileName: string, subFolder: string): Observable<any> {
        let url: string;
        url = this._documentManagementUrl + '/GetFileBySubFolderAndName?fileName=' + fileName + '&subFolder=' + subFolder ;

        return this._httpClient.get<any>(url, { responseType: 'blob' as 'json'});
    }

    public exportReportFile(fileName: string, subFolder: string) {
        this._isLoading = true;
        this._validationMessage = '';
        this.getDownloadFileURL(fileName, subFolder)
            .subscribe(
                (response: Blob) => {
                    const data = response;

                    const file = new Blob([data], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);

                    // window.open(fileURL);
                    const a         = document.createElement('a');
                    a.href        = fileURL;
                    a.target      = '_blank';
                    a.download    = fileName;
                    document.body.appendChild(a);
                    a.click();
                    
                    a.remove();

                    window.URL.revokeObjectURL(fileURL);

                    this._validationMessage = 'File download successful.';

                },
                (error) => {
                    console.error('Request failed with error: ' + error.message);
                    this._validationMessage = error.message;
                    this._isLoading = false;
                },
                () => {
                    this._isLoading = false;
                });
    }
}
